import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";

const isAdminAuthenticated = () => {
  const isAuth = localStorage.getItem("admin");
  if (isAuth) {
    return true;
  }
  return false;
};

const AdminProtectedRoutes = () => {
  // Check if admin is authenticated
  const isAuthenticated = isAdminAuthenticated();

  return isAuthenticated ? (
    <>
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>

  ) : <Navigate to="/admin/login" />;
};

export default AdminProtectedRoutes;
